import { render, staticRenderFns } from "./WordTable.vue?vue&type=template&id=6051df46&scoped=true"
import script from "./WordTable.vue?vue&type=script&lang=js"
export * from "./WordTable.vue?vue&type=script&lang=js"
import style0 from "./WordTable.vue?vue&type=style&index=0&id=6051df46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051df46",
  null
  
)

export default component.exports